/**
 * @file PortfolioAllocation.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React from "react";
import Widget from "../Widget";
import DgPieChart from "../../../../components/dashboard/DgPieChart";
import { getFromSession } from "../../../../utils/sessionUtils";

function PortfolioAllocation({ width, data, loading }) {
  return (
    <Widget name={"portfolio-allocation"} width={width}>
      <div className="heading">
        <h1 className="title">Portfolio Allocation</h1>
      </div>
      <div className="score">
        <p className="number">{getFromSession("score")}</p>
        <p className="risk-text">Risk Score</p>
      </div>
      <p className="description">
        Diversify your portfolio, talk to your advisor to make any changes.
      </p>
      <div className="row center">
        <DgPieChart
          data={data?.strategies}
          value={"percentage"}
          percentageInfo={data?.performance?.performancePerc}
        />
      </div>
    </Widget>
  );
}

export default PortfolioAllocation;
